<template>
    <div class="page" :id="id">
        <div class="decorative-texture top">
            <img src="../../assets/img/texture.png" />
        </div>
        <div class="decorative-texture position-bottom movil-only">
            <img src="../../assets/img/texture.png" />
        </div>
        <vue-snotify></vue-snotify>
        <mnavbar></mnavbar>
        <video-note v-if="item.entrada == 'T' || item.entrada == 'R' || item.entrada == 'Y'" :item="item" :comments="comments" :noStars="noStars"  :from="from" :fromParams="fromParams" :params="params"></video-note>
        <pd-note v-if="item.entrada == 'PD'" :item="item" :comments="comments" :noStars="noStars"  :from="from" :fromParams="fromParams"></pd-note>
        <embedded-note  v-if="item.entrada == 'FB' || item.entrada == 'TW' || item.entrada=='I'" :item="item" :comments="comments" :noStars="noStars"  :from="from" :fromParams="fromParams"></embedded-note>
        
    </div>
</template>

<script>

import mnavbar from '@/components/public/mnavbar'
import videoNote from  '@/components/public/videoNote'
import youtubeNote from  '@/components/public/youtubeNote'
import pdNote from  '@/components/public/pdNote'
import embeddedNote from  '@/components/public/embeddedNote'



export default {
    name:'note',
    components: {mnavbar,videoNote,youtubeNote,pdNote,embeddedNote},
    props:['params','from','fromParams'],
    data () {
        return {
            url : this.$store.getters.getMainUrl,
            item:{},
            noStars:0,
            comments:[],
            LastEvaluatedKey:null,
            id:'video-post'
        }
    },
    mounted(){
        this.load();
    },
    methods:{
        load(){//funcion inicial
            if(this.params){
                this.getPublicNote();
                this.getComments();
            }else{
                this.error('url no valida');
                this.$router.push('/');
            }
        },
        getPublicNote(){
            var post_data = {
                params:this.params
            };
            var self = this;
            axios.post(this.url+'getPublicNote', post_data)
            .then((response)=>{
                self.isLoading = false;
                if(response.data.success){
                    self.setItem(response.data.data);
                }else{
                    self.error(response.data.error)
                }
            })
            .catch(function (error) {
                self.isLoading = false;
                self.error(error);
            });
        },
        getComments(){
            var post_data = {
                params:this.params
            };
            var self = this;
            axios.post(this.url+'getPublicComments', post_data)
            .then((response)=>{
                console.log(response)
                 if(self.comments.length==0){
                    self.comments = response.data.result;
                    self.total = response.data.total;
                }else{
                    self.comments = [].concat(self.comments,response.data.result);
                    self.total = self.total + response.data.total;
                }
                console.log(self.comments)
                self.LastEvaluatedKey = (response.data.LastEvaluatedKey)?  response.data.LastEvaluatedKey:null;
            });
        },
        setItem(data){
          
            switch (data.entrada) {
                case "FB":
                case "TW":
                case "I":
                    this.id = 'text-sources-notes';
                break;
            }
            this.item = data;
        },
        error(msg){
            this.$snotify.error(msg, 'Error');
        },
        success(msg){
            this.$snotify.success(msg, 'Success');
        },

    },
    
}
</script>


<style scoped>

.sub{
    color:#00B99E;
}

#video-post .container .content .actions .video-action.active svg {
    fill :white
}
</style>
